export default __webpack_public_path__ + "static/media/newUserBanner.121a3ec0.jpg";